import Http from "./Http";

class FilesService extends Http {
  /**
   * Initiate multipart upload
   * @param {Array.<{contentType: string, partsCount: number, width?: number, height?: number }>} body
   */
  requestMultipartUpload(body) {
    return this.post("/files/multipart", body);
  }

  /**
   * Complete multipart upload
   * @param {Array.<{fileId: number, uploadId: string, key: string, parts: Array.<{partNumber: number, etag: string}>}>} body
   */
  completeMultipartUpload(body) {
    return this.post("/files/multipart/complete", body);
  }

  /**
   * Get file by path
   * @param {string} pathToFile
   */
  getFile(pathToFile) {
    return Http.createInstance().get(pathToFile, { responseType: "blob" });
  }

  createChunks(file, maxChunkSize = 25 * 1000 * 1000) {
    let currentIndex = 0;
    const fileSize = file.size;
    const chunksCount = Math.ceil(fileSize / maxChunkSize);
    const chunkSize = fileSize / chunksCount;
    const chunks = [];

    while (currentIndex < chunksCount) {
      chunks.push(
        file.slice(currentIndex * chunkSize, (currentIndex + 1) * chunkSize),
      );

      currentIndex += 1;
    }

    return chunks;
  }

  /**
   * Save blob
   * @param {string} pathToFile
   */
  downloadFile(blob, filename) {
    const tempLink = document.createElement("a");
    const blobURL =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);

    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", filename);

    // Safari
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }

    document.body.appendChild(tempLink);
    tempLink.click();
  }
}

export default new FilesService();
